<template>
    <ClientOnly>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 92 85"
            fill="none"
            v-bind="$attrs"
            width="92"
            height="85">
            <g opacity="0.5">
                <g :filter="`url(#filter0_i_1073_15611_${timestamp})`">
                    <path
                        d="M46 84.334L52.67 78.383C60.4133 71.4403 66.815 65.4511 71.875 60.4157C76.935 55.3803 80.96 50.8599 83.95 46.8544C86.94 42.849 89.0292 39.1678 90.2175 35.8108C91.4058 32.4539 92 29.0206 92 25.5111C92 18.3394 89.585 12.3503 84.755 7.54379C79.925 2.73725 73.9067 0.333984 66.7 0.333984C62.7133 0.333984 58.9183 1.17322 55.315 2.8517C51.7117 4.53017 48.6067 6.89529 46 9.94706C43.3933 6.89529 40.2883 4.53017 36.685 2.8517C33.0817 1.17322 29.2867 0.333984 25.3 0.333984C18.0933 0.333984 12.075 2.73725 7.245 7.54379C2.41499 12.3503 0 18.3394 0 25.5111C0 29.0206 0.594162 32.4539 1.78249 35.8108C2.97083 39.1678 5.06001 42.849 8.05 46.8544C11.04 50.8599 15.065 55.3803 20.125 60.4157C25.185 65.4511 31.5867 71.4403 39.33 78.383L46 84.334Z"
                        :fill="`url(#paint0_linear_1073_15611_${timestamp})`" />
                </g>
                <path
                    d="M20.4777 60.0613C25.5295 65.0886 31.9243 71.0714 39.6638 78.0108L46 83.6639L52.3362 78.0108C60.0757 71.0714 66.4705 65.0886 71.5223 60.0613C76.5717 55.0365 80.5787 50.5349 83.5493 46.5553C86.5204 42.5752 88.5798 38.9387 89.7462 35.644C90.9158 32.3398 91.5 28.9629 91.5 25.5111C91.5 18.4647 89.1326 12.6056 84.4023 7.89821C79.6718 3.19071 73.7829 0.833984 66.7 0.833984C62.7861 0.833984 59.0631 1.65735 55.5261 3.30494C51.9883 4.95288 48.9408 7.27393 46.3802 10.2718L46 10.7169L45.6198 10.2718C43.0592 7.27393 40.0117 4.95288 36.4739 3.30494C32.9369 1.65735 29.2139 0.833984 25.3 0.833984C18.2171 0.833984 12.3282 3.19071 7.59769 7.89821C2.86735 12.6056 0.5 18.4647 0.5 25.5111C0.5 28.9629 1.08418 32.3398 2.25383 35.644C3.42015 38.9387 5.47961 42.5752 8.45068 46.5553C11.4213 50.5349 15.4283 55.0365 20.4777 60.0613Z"
                    stroke="white" />
            </g>
            <defs>
                <filter
                    :id="`filter0_i_1073_15611_${timestamp}`"
                    x="0"
                    y="0.333984"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                    width="92"
                    height="84">
                    <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="9" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        :result="`effect1_innerShadow_1073_15611_${timestamp}`" />
                </filter>
                <linearGradient
                    :id="`paint0_linear_1073_15611_${timestamp}`"
                    x1="46"
                    y1="84.334"
                    x2="46"
                    y2="0.333984"
                    gradientUnits="userSpaceOnUse">
                    <stop
                        stop-color="white"
                        stop-opacity="0" />
                    <stop
                        offset="1"
                        stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    </ClientOnly>
</template>

<script setup lang="ts">
const timestamp = Date.now() + getRandomNumber(1, 500)
</script>
